
<modal
  title="Move Selected Cards"
  :open="open"
  @close="closeModal"
>
  <form @submit.stop.prevent="submit">
    <p class="description">
      Move {{ selectedCount }} selected {{ selectedCount === 1 ? 'card' : 'cards' }} to another collection.
    </p>

    <select-input
      v-model="targetCollectionId"
      label="Destination Collection"
      :options="collectionOptions"
    />

    <div class="button-row">
      <btn
        type="submit"
        :loading="submitting"
        :disabled="disabled"
        loading-text="Moving"
      >
        Move
      </btn>

      <btn kind="secondary" @click="closeModal">
        Cancel
      </btn>
    </div>
  </form>
</modal>
